<template>
  <div :class="classes" @click="onToPath">
    <span class="vi-sidebar-parent-item--icon" :class="item.reIcon ? 'hfs' : 'el-icon-s-promotion'" v-html="item.reIcon ? item.reIcon : ''"/>
    <span class="vi-sidebar-parent-item--text">{{item.reModule.substr(0,2)}}</span>
    <span class="vi-sidebar-parent-item--line"></span>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { handlerReEngSystem, ignoreRePath, ignoreRePathExp } from './utils'

  const prefixCls = 'vi-sidebar-parent-item'
  export default {
    name: 'vi-sidebar-parent-item',
    data () {
      return {
        isActive: false
      }
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      onToPath () {
        const { children, appCode, reUrl, rePath } = this.item
        if (rePath === 'index') {
          this.$router.push({ path: '/home' })
          return
        }
        const jumpRoute = (appCode, reUrl) => {
          const system = handlerReEngSystem(appCode)
          const path = system !== 'app' ? `/${system}${reUrl}` : `${reUrl}`
          this.$router.push({ path })
        }
        if (_.isEmpty(children)) {
          jumpRoute(appCode, reUrl)
        } else {
          const itemChildren = children[0]
          const t = _.pull(_.map(itemChildren.children, 'rePath'), ...ignoreRePath)
            .filter(path => !ignoreRePathExp.test(path))
          if (_.isEmpty(t)) {
            jumpRoute(itemChildren.appCode, itemChildren.reUrl)
          } else {
            const itemitemChildren = itemChildren.children[0]
            if (itemChildren.reUrl === '/marketing/activity') {
              jumpRoute(itemChildren.appCode, itemChildren.reUrl)
            } else {
              jumpRoute(itemitemChildren.appCode, itemitemChildren.reUrl)
            }
          }
        }
      }
    },
    watch: {
      '$route': {
        deep: true,
        immediate: true,
        handler ({ path }) {
          this.isActive = path === '/home' && this.item.rePath === 'index'
        }
      }
    },
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['currentMenuData']),
      classes () {
        return [
          `${prefixCls}`,
          {
            [`${prefixCls}--active`]: _.isEmpty(this.currentMenuData)
              ? false
              : this.item.reModule === this.currentMenuData.reModule
          },
          {
            [`${prefixCls}--active`]: this.isActive
          }
        ]
      }
    },
    components: {}
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-sidebar-parent-item";
  .#{$-prefix-cls} {
    height: 40px;
    line-height: 38px;
    background-color: #383E49;
    cursor: pointer;
    position: relative;
    z-index: 1;
    &--icon,&--text {
      color: #8992a0;
      padding-left: 12px;
      font-size: 15px;
      font-weight: bold;
      transition: all 0.3s ease-out;
    }
    &--text {
      display: inline-block;
    }
    &--icon {
      font-size: 18px;
      padding-left: 14px;
    }
    &--line {
      height: 22px;
      width: 4px;
      border-radius: 2px;
      background-color: #fff;
      margin-right: 4px;
      position: absolute;
      right: 2px;
      top: 9px;
      z-index: 0;
      opacity: 0;
    }
    &:hover {
      .#{$-prefix-cls}--text {
        transition: all 0.3s ease-out;
        transform: translate(-4px,0px);
      }
    }
    &--active,&:hover {
      span {
        color: #fff;
        transition: all 0.3s ease-out;
      }
    }
    &--active {
      background-color: #2c2e3a;
      .#{$-prefix-cls}--line {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/sidebarParentItem.vue